import React from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import '../../componentCss/common.scss';

export const PartyInfo = ({shipper, consignee}) => {
    return (
        <Grid container>
            <Grid item xs={12} md={6}>
                <PartyAddress type="Shipper" party={shipper}></PartyAddress>
            </Grid>
            <Grid item xs={12} md={6}>
                <PartyAddress type="Consignee" party={consignee}></PartyAddress>
            </Grid>
        </Grid>
    );
};

export function PartyAddress({type, party}) {
    return (
        <Card>
            <CardHeader title={type}></CardHeader>
            <CardContent>
                <Grid container direction="column">
                    {party?.name && (
                        <>
                            <Grid item>
                                <Typography variant="h6">Name</Typography>
                            </Grid>
                            <Grid item>
                                <Typography>{party?.name}</Typography>
                            </Grid>
                        </>
                    )}
                    <Grid item>
                        <Typography variant="h6">Address</Typography>
                    </Grid>
                    <Grid item>
                        {party?.addr1 && (
                            <Typography>{party?.addr1}</Typography>
                        )}
                    </Grid>
                    <Grid item>
                        {party?.city && <Typography>{party?.city}</Typography>}
                        {party?.stateProv && (
                            <Typography>{party?.stateProv}</Typography>
                        )}

                        {party?.postalCode && (
                            <Typography>{party?.postalCode}</Typography>
                        )}
                        {party?.countryCode && (
                            <Typography>{party?.countryCode}</Typography>
                        )}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

export const DataPair = ({field, value, formatter = (value) => value}) => {
    if (!value) {
        return <></>;
    }

    return (
        <Grid container justifyContent="space-between">
            <Grid item>{field}: </Grid>
            <Grid item>{formatter(value)}</Grid>
        </Grid>
    );
};

export const RequireData = ({data, children}) => {
    if (data) {
        return children;
    } else {
        return <></>;
    }
};

export const defaultMultiSelectFilterConfig = {
    ignoreCase: true,
    trim: true,
    matchFrom: 'start',
};

export function escapeRegExp(value: string) {
    return value.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
}
